// FAQ accordion for the player and calculator pages (#hls-faqs, #bwc-faqs, #brc-faqs).
// Mirrors the feature-page.js behaviour: one answer open at a time, and the open block
// carries the `.collapsed` class that feature-page.css styles as the open state.
(function () {
  var blocks = document.querySelectorAll(
    '#hls-faqs .faq_block, #bwc-faqs .faq_block, #brc-faqs .faq_block'
  );

  if (!blocks.length) {
    return;
  }

  var setOpen = function (block, shouldOpen) {
    var head = block.querySelector('.faq_head');
    block.classList.toggle('collapsed', shouldOpen);

    if (head) {
      head.setAttribute('aria-expanded', String(shouldOpen));
    }
  };

  var toggle = function (block) {
    var willOpen = !block.classList.contains('collapsed');
    var list = block.closest('.faq_list') || document;

    list.querySelectorAll('.faq_block.collapsed').forEach(function (other) {
      if (other !== block) {
        setOpen(other, false);
      }
    });

    setOpen(block, willOpen);
  };

  blocks.forEach(function (block, index) {
    var head = block.querySelector('.faq_head');
    var body = block.querySelector('.faq_body');

    if (!head || !body) {
      return;
    }

    body.id = body.id || 'faq-answer-' + index;
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.setAttribute('aria-controls', body.id);
    head.setAttribute('aria-expanded', String(block.classList.contains('collapsed')));

    head.addEventListener('click', function () {
      toggle(block);
    });

    head.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      toggle(block);
    });
  });
})();
